import all from '@/intl/all';
import checkUserAgentForBot from '@/utils/checkUserAgentForBot';
import Cookies from 'universal-cookie';
import { DEFAULT_STATE as defaultReduxStateAnalytics } from '@/redux/modules/analytics';
import { DEFAULT_STATE as defaultReduxStateConfig } from '@/redux/modules/config';
import { DEFAULT_STATE as defaultReduxStateIntl } from '@/redux/modules/intl';
import { DEFAULT_STATE as defaultReduxStateUser } from '@/redux/modules/user';
import { DEFAULT_STATE as defaultReduxStateWindowSize } from '@/redux/modules/windowSize';
import { getBrowserDataFromUA } from './modules/browser';
import { getPageSizeFromCookie } from '@/utils/pagination';
import { GlobalState } from '@/redux/rootReducer';

const cookie = new Cookies();

const DEFAULT_ITEMS_TO_SHOW = 24;

type GetInitialDataParams = {
    basename?: string;
    config?: any;
    req?: any;
    whiteLabelInfo?: any;
};

const getInitialData = ({
    basename = '',
    config: configDefaults = {},
    req = { cookies: [], headers: [], hostname: '', url: '' },
    whiteLabelInfo = false,
}: GetInitialDataParams): Partial<GlobalState> => {
    // check the cookie for a valid token
    const referrer = req.headers.referer || '';
    const touchDate = new Date().getTime();
    const disableModalForTesting = req.url.includes('hideForTesting') || req.url.includes('/console/');

    var whiteLabel: any = {
        hostname: req.hostname,
        isWhiteLabel: false,
        logo: 'https://p1.liveauctioneers.com/dist/images/logo.svg',
        sellerId: 0,
    };

    const pageSize =
        getPageSizeFromCookie(req.cookies['pagination-page-size']) ||
        getPageSizeFromCookie(cookie.get('pagination-page-size')) ||
        DEFAULT_ITEMS_TO_SHOW;

    if (whiteLabelInfo) {
        const { logoId, name: sellerName, sellerId, website } = whiteLabelInfo;
        const siteNameMatch = (website || '').match(/^(?:https?:\/\/)?(?:[w]{3}\.)?(.*)$/);
        const siteName = siteNameMatch && siteNameMatch[1].length > 0 ? siteNameMatch[1].replace(/\/+$/, '') : '';

        whiteLabel = {
            hostname: req.hostname,
            isWhiteLabel: true,
            logo:
                !logoId || logoId === ''
                    ? null
                    : `https://images.liveauctioneers.com/houses/logos/lg/${logoId}_large.jpg?auto=webp&format=pjpg`,
            name: sellerName,
            sellerId,
            siteName,
            siteUrl: website || '',
        };
    }

    let intl: typeof defaultReduxStateIntl = {
        locale: 'en',
        messages: all['en'],
    };

    if (basename === '/en-gb') {
        intl = {
            locale: 'en-gb',
            messages: { ...all['en'], ...all['en-gb'] },
        };
    }

    const config = {
        ...defaultReduxStateConfig,
        ...configDefaults,
        baseUrl: `${configDefaults.baseUrl}${basename}`,
        wwwBaseUrl: configDefaults.baseUrl,
    };

    let width = 1024;
    const userAgent = req.headers['user-agent'] ? req.headers['user-agent'] : '';
    const bot = checkUserAgentForBot(userAgent);
    const { mobile } = getBrowserDataFromUA(userAgent);

    if (Boolean(mobile)) {
        if (mobile === 'phone') {
            width = 500;
        } else if (mobile === 'tablet') {
            width = 768;
        }
    }

    return {
        analytics: {
            ...defaultReduxStateAnalytics,
            bot,
            referrer,
            touchDate,
        },
        autoPopModal: {
            dateLastShown: '',
            disableModalForTesting,
            hasLoggedInBefore: false,
        },
        browser: {
            deviceType: 'computer',
            microsoftBrowser: false,
            mobile: '',
            name: '',
        },
        config,
        currency: req.currency,
        intl,
        pagination: {
            pageSize,
        },
        user: { ...defaultReduxStateUser, userData: {} },
        userVariantTest: req.userVariantTest || { byId: {}, loaded: 0 },
        whiteLabel,
        windowSize: { ...defaultReduxStateWindowSize, width: width },
    };
};

export default getInitialData;
